<div class="container vh-100 d-flex align-items-center justify-content-center">
  <div class="row w-100 d-flex align-items-center justify-content-center text-center flex-lg-row flex-column gap-lg-8 gap-0">

    <div class="col-lg-5 col-10 mb-4 mb-lg-0 d-flex justify-content-center mb-8 mb-lg-0 me-lg-8 me-0">
      <img src="/assets/images/not-found.webp" alt="logo" class="img-fluid">
    </div>

    <div class="col-lg-5 col-10 d-flex flex-column align-items-center justify-content-center mt-8 mt-lg-0 ms-0 ms-lg-8">
      <h1 class="mb-4">{{ 'NotFoundPage' | translate }}</h1>
      <button class="btn btn-primary px-8 mt-8" type="button"  onclick="window.location.href='/dashboard'">
        {{ 'BackToDashboard' | translate }}
      </button>
    </div>

  </div>
</div>
